import { format } from 'd3-format'

export const numFormat = format(',.0f')
export const numFormatOneDecimal = format(',.1f')
export const absChangeFormat = format('+,.0f')
export const percentFormat = format('.1%')
export const percentFormatRound = format('.0%')
export const percentChangeFormat = format('+.0%')
export const percentChangeFormatOneDecimal = format('+.1%')
export const plural = (num) => num !== 1 ? 's' : ''